module.exports = __webpack_public_path__ + "static/media/bithash-logo.1f02e029.png";